/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {AdnAssetHelperService} from '../../../components/util/adn-asset-helper.service';
import {AdnHttpProgressCallback} from '../../../components/util/adn-http.service';
import {Uuid} from '../../../components/util/uuid';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {AdminObjectState, SignalAdminResourceApiBase} from '../../common/controller/signal-admin-resource-api';

export interface CdnUploadModel {
  id: string;
  fileName?: string;
  cdnId?: string;
  mimeType?: string;
  fileSizeBytes?: number;
  width?: number;
  height?: number;
  createTime?: string;
  updateTime?: string;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

@Injectable({providedIn: 'root'})
export class CdnUploadApiService extends SignalAdminResourceApiBase<CdnUploadModel> {
  constructor(
    client: AdnApiClientService,
    private readonly assetHelper: AdnAssetHelperService
  ) {
    super(client, 'cdnassets');
  }

  upload(
    assetId: string,
    file: File,
    onProgress?: AdnHttpProgressCallback
  ): Promise<CdnUploadModel> {
    const resolvedAssetId = assetId || Uuid.generate();
    const upload = onProgress
      ? this.assetHelper.upload('cdnassets', null, {file}, resolvedAssetId, onProgress)
      : this.assetHelper.upload('cdnassets', null, {file}, resolvedAssetId);
    return upload.then((files: any) => _.isArray(files) ? files[0] : files);
  }
}
